function getMonetate() {
  if (typeof window === "undefined") {
    return [];
  }
  window.monetateQ = window.monetateQ || [];
  return window.monetateQ;
}
function getMonetateEvents() {
  if (typeof window === "undefined") {
    return [];
  }
  window.monetateEvents = window.monetateEvents || [];
  return window.monetateEvents;
}
function transformProductIds(pd) {
  return pd.map((p) => ({
    ...p,
    productId: p.productId?.replace(/-/g, "")
  }));
}
function setMonetateHelper(MonetateHelper) {
  if (typeof window === "undefined") {
    return {};
  }
  window.MonetateHelper = window.MonetateHelper || MonetateHelper;
}
function monetate() {
  const monetate2 = getMonetate();
  const pushedEvents = getMonetateEvents();
  const Monetate = {
    // This function should be called once per page to submit all the monetate events required.
    commitMonetateEvent(pageType, subEvents) {
      monetate2.push(["setPageType", pageType]);
      pushedEvents.push(["setPageType", pageType]);
      for (const subEvent of subEvents || []) {
        monetate2.push(subEvent);
        pushedEvents.push(subEvent);
      }
      monetate2.push(["trackData"]);
    },
    // Perform a "retrack" that submits all events that we previously sent to monetate and append with new events.
    retrackMonetateEvents(retrackEvents) {
      monetate2.push(...pushedEvents);
      monetate2.push(...retrackEvents);
      pushedEvents.push(...retrackEvents);
      monetate2.push(["trackData"]);
    },
    trackProductListing(impressions) {
      this.commitMonetateEvent("category", [["addProducts", impressions]]);
    },
    trackProductDetail(productDetails) {
      this.commitMonetateEvent("product", [
        ["addProductDetails", transformProductIds(productDetails)]
      ]);
    },
    trackCartPage(cartRows) {
      this.commitMonetateEvent("cart", [["addCartRows", transformProductIds(cartRows)]]);
    },
    trackCheckoutPage(page, cartRows) {
      this.commitMonetateEvent(page, [["addCartRows", transformProductIds(cartRows)]]);
    },
    trackCartContents(cartRows) {
      this.retrackMonetateEvents([["addCartRows", transformProductIds(cartRows)]]);
    },
    trackPurchases(purchaseRows) {
      this.commitMonetateEvent("purchase", [["addPurchaseRows", transformProductIds(purchaseRows)]]);
    },
    trackEvent(eventData) {
      monetate2.push(["trackEvent", eventData]);
      monetate2.push(["trackEvent"]);
    },
    trackBatchEvents(...batchEventData) {
      for (const eventData of batchEventData) {
        monetate2.push(["trackEvent", eventData]);
      }
      monetate2.push(["trackEvent"]);
    }
  };
  const findLastEvent = (eventType) => {
    return pushedEvents.reverse().find(([name, _]) => name === eventType);
  };
  const MonetateHelper = {
    reTrack() {
      this.setPage();
      this.addProducts();
      this.addProductDetails();
      this.addCartRows();
      this.addPurchaseRows();
      this.pushTrackData();
    },
    pushTrackData() {
      monetate2.push(["trackData"]);
    },
    setPage() {
      const ev = findLastEvent("setPageType");
      ev && monetate2.push(ev);
    },
    addProducts() {
      const ev = findLastEvent("addProducts");
      ev && monetate2.push(ev);
    },
    addProductDetails() {
      const ev = findLastEvent("addProductDetails");
      ev && monetate2.push(ev);
    },
    addCartRows() {
      const ev = findLastEvent("addCartRows");
      ev && monetate2.push(ev);
    },
    addPurchaseRows() {
      const ev = findLastEvent("addPurchaseRows");
      ev && monetate2.push(ev);
    }
  };
  setMonetateHelper(MonetateHelper);
  return Monetate;
}
export {
  getMonetate,
  monetate
};
//# sourceMappingURL=monetate.js.map
